import React, { useState } from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import EmptyState from "./EmptyState";
import "./MiniTable.scss";
import { Tooltip } from "antd";

export interface MiniTableRow {
  avatarUrl: string;
  requestedAt: string;
  bookDate: string;
  contentDue: string;
  isPremium: boolean;
  username: string;
  isNoShow: boolean;
  submittedAt: string;
  accepted: string;
  postLive: string;
}

interface MiniTableProps {
  rows: MiniTableRow[];
  emptyMessage?: string;
  initialVisible?: number;
}

const MiniTable: React.FC<MiniTableProps> = ({
  rows,
  emptyMessage,
  initialVisible = 3,
}) => {
  const [visibleCount, setVisibleCount] = useState(initialVisible);

  if (!rows.length) {
    return <EmptyState message={emptyMessage || "No items found"} />;
  }

  const onViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + initialVisible, rows.length));
  };

  const viewMoreCount = rows.length - visibleCount;
  const onViewLess = () => {
    setVisibleCount(initialVisible);
  };

  return (
    <div className="mini-table">
      <div className="mini-table__header">
        <div className="mini-table__col">Creator</div>
        <div className="mini-table__col">Applied</div>
        <div className="mini-table__col">Accepted</div>
        <div className="mini-table__col">Booking</div>
        <div className="mini-table__col">Content due</div>
        <div className="mini-table__col">Post live</div>
      </div>
      {rows.slice(0, visibleCount).map((row, idx) => (
        <div className="mini-table__row" key={idx}>
          <div
            className="mini-table__col"
            style={{ display: "flex", gap: 8, alignItems: "center" }}
          >
            <img
              src={row.avatarUrl}
              alt={row.username}
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                objectFit: "cover",
                border: "1px solid #eee",
              }}
            />
            <Tooltip title={row.username}>
              <span
                style={{
                  color: "#666",
                  display: "block",
                  maxWidth: 40,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "default",
                }}
              >
                {row.username}
              </span>
            </Tooltip>
          </div>
          <div className="mini-table__col">
            {row.requestedAt ? dayjs(row.requestedAt).format("MMM D") : "-"}
          </div>
          <div className="mini-table__col">
            {row.accepted ? dayjs(row.accepted).format("MMM D") : "-"}
          </div>
          <div className="mini-table__col">
            {row.isNoShow ? (
              <span style={{ color: "#ef4444" }}> No Show</span>
            ) : (
              <span style={{ color: "#22c55e" }}>
                <FontAwesomeIcon icon={faCircleCheck} />{" "}
                {dayjs(row.bookDate).format("MMM D")}
              </span>
            )}
          </div>
          <div className="mini-table__col">
            {row.contentDue ? dayjs(row.contentDue).format("MMM D") : "-"}
          </div>
          <div className="mini-table__col">
            {row.submittedAt ? dayjs(row.submittedAt).format("MMM D") : "-"}
          </div>
        </div>
      ))}
      {viewMoreCount > 0 && (
        <div
          className="mini-table__footer"
          style={{
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={onViewMore}
        >
          <span>
            <FontAwesomeIcon icon={faChevronDown} /> View more ({viewMoreCount})
          </span>
        </div>
      )}
      {viewMoreCount === 0 && rows.length > initialVisible && (
        <div
          className="mini-table__footer"
          style={{
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={onViewLess}
        >
          <span>View less</span>
        </div>
      )}
    </div>
  );
};

export default MiniTable;
